export default function ({ redirect }) {
  // Redirect everything to the Flexible rent marketing site
  redirect('https://www.bestegg.com/flexible-rent/');
}
